import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/user', component: List, name: 'user.index'},
  {path: '/user/store', component: Form, name: 'user.store'},
  {path: '/user/:id', component: Form, name: 'user.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/user/routes.js